// src/registry.ts
var WEEKDAYS = Object.freeze([1, 2, 3, 4, 5]);
var WEEKDAYS_SAT = Object.freeze([1, 2, 3, 4, 5, 6]);
var MONDIAL_DAYS = Object.freeze([2, 3, 4, 5, 6]);
var CARRIER_REGISTRY = {
  colissimo: {
    name: "Colissimo",
    logo: "colissimo.png",
    match: (code) => code.includes("colissimo") || code === "la-poste" || code === "lapost" || code === "la-poste-colissimo" || code === "lapostcolissimo" || code === "lettre-suivie" || code === "lettre suivie" || code === "lettresuivie" || code === "delivengo",
    tracking: { provider: "native", trackingMoreCarrierCode: "colissimo" },
    trackingUrl: {
      url: "https://www.laposte.fr/outils/suivre-vos-envois?code={trackingId}",
      fallbackUrl: "https://www.laposte.fr/outils/suivre-vos-envois"
    },
    matchTrackingNumber: (tn) => /^[68]A\d{9}FR$/i.test(tn) || /^[C-R][A-Z]\d{9}FR$/i.test(tn),
    meta: {
      trackingMethod: "API officielle La Poste v2 (OAuth2) + fallback scraper SmartProxy v1",
      rateLimit: "~5 req/s (429 avec Retry-After)",
      notes: "Circuit breaker 5s sur 429. Token OAuth2 cached avec marge 1min."
    },
    credentials: {
      // Tracking utilise une clé OkApi centrale Baback + fallback scraper SmartProxy ;
      // les identifiants marchand ne servent qu'à la génération d'étiquettes.
      usedFor: ["shipment"],
      supportsCredentialCheck: true,
      fields: [
        { key: "accountId", label: "Account ID", type: "string", required: true },
        { key: "password", label: "Password", type: "string", required: true, sensitive: true },
        { key: "SLS", label: "Suivi Livraison Sign\xE9 (SLS)", type: "boolean", required: false },
        // EORI de l'expéditeur : requis par Colissimo sur les envois douaniers (CN23)
        // depuis sept. 2025 (erreur 30561 sinon). Format : 2 lettres + 9 chiffres.
        { key: "eori", label: "Num\xE9ro EORI (exp\xE9diteur)", type: "string", required: false }
      ]
    },
    supportsLabelGeneration: true,
    products: [
      { code: "colissimo", isPickupPoint: false, name: "Colissimo", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "DOM", international: "COLI" }, servedZones: ["FR_METRO", "EU", "OM1", "OM2", "MONDE"], zoneDelays: { EU: { promise: 4, padding: 2 }, OM1: { promise: 8, padding: 3 }, OM2: { promise: 10, padding: 4 }, MONDE: { promise: 7, padding: 2 } } },
      { code: "livraison-domicile", isPickupPoint: false, name: "Livraison \xE0 domicile", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "DOM", international: "COLI" }, servedZones: ["FR_METRO", "EU", "OM1", "OM2", "MONDE"], zoneDelays: { EU: { promise: 4, padding: 2 }, OM1: { promise: 8, padding: 3 }, OM2: { promise: 10, padding: 4 }, MONDE: { promise: 7, padding: 2 } } },
      { code: "point-retrait", isPickupPoint: true, name: "Point retrait", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "A2P" }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } },
      // international "COLI": an order shipping abroad on this (France) shipping line must fall back to the international product, not the France-only DOS/DOM code that Colissimo rejects (error 30213/30312).
      { code: "colissimo_domicile_signature_france", isPickupPoint: false, name: "Colissimo Domicile Signature - France", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "DOS", international: "COLI" }, servedZones: ["FR_METRO"] },
      { code: "colissimo_domicile_sans_signature_france", isPickupPoint: false, name: "Colissimo Domicile Sans Signature - France", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "DOM", international: "COLI" }, servedZones: ["FR_METRO"] },
      { code: "colissimo_point_retrait_france", isPickupPoint: true, name: "Colissimo Point Retrait - France", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "A2P" }, servedZones: ["FR_METRO"] },
      // MONDE recalé sur mesure (159 colis) : le produit est utilisé hors EU, où il met 5 à 9 jours.
      { code: "colissimo_domicile_signature_europe", isPickupPoint: false, name: "Colissimo Domicile Signature - Europe", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "COLI" }, servedZones: ["EU"], zoneDelays: { MONDE: { promise: 5, padding: 4 } } },
      { code: "colissimo_domicile_sans_signature_europe", isPickupPoint: false, name: "Colissimo Domicile Sans Signature - Europe", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "COLI" }, servedZones: ["EU"] },
      { code: "colissimo_point_retrait_europe", isPickupPoint: true, name: "Colissimo Point Retrait - Europe", defaultSmartDelivery: { defaultPromise: 7, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "A2P" }, servedZones: ["EU"] },
      { code: "colissimo_domicile_signature_outre_mer", isPickupPoint: false, name: "Colissimo Domicile Signature - Outre-Mer", defaultSmartDelivery: { defaultPromise: 7, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "COLI" }, servedZones: ["OM1", "OM2"], zoneDelays: { OM2: { promise: 10, padding: 4 } } },
      { code: "colissimo_domicile_sans_signature_outre_mer", isPickupPoint: false, name: "Colissimo Domicile Sans Signature - Outre-Mer", defaultSmartDelivery: { defaultPromise: 7, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "COLI" }, servedZones: ["OM1", "OM2"], zoneDelays: { OM2: { promise: 10, padding: 4 } } },
      { code: "colissimo_domicile_signature_monde", isPickupPoint: false, name: "Colissimo Domicile Signature - Monde", defaultSmartDelivery: { defaultPromise: 7, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "COLI" }, servedZones: ["MONDE"] },
      { code: "lettre-suivie", isPickupPoint: false, name: "Lettre Suivie", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["FR_METRO"], zoneDelays: { EU: { promise: 5, padding: 2 } } }
    ]
  },
  chronopost: {
    name: "Chronopost",
    logo: "chronopost.png",
    match: (code) => code.startsWith("chrono"),
    tracking: { provider: "native", trackingMoreCarrierCode: "chronopost" },
    trackingUrl: {
      url: "https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT={trackingId}",
      fallbackUrl: "https://www.chronopost.fr/tracking-no-cms/suivi-page"
    },
    matchTrackingNumber: (tn) => /^X[A-Z]\d{9}[A-Z]{2}$/i.test(tn),
    meta: {
      trackingMethod: "Web service SOAP public Chronopost (trackSkybillV2, non authentifi\xE9)"
    },
    credentials: {
      // Le suivi passe par un endpoint SOAP public anonyme ; les identifiants
      // marchand ne servent qu'à la génération d'étiquettes.
      usedFor: ["shipment"],
      supportsCredentialCheck: true,
      fields: [
        { key: "accountNumber", label: "Account Number", type: "string", required: true },
        { key: "password", label: "Password", type: "string", required: true, sensitive: true },
        { key: "subAccount", label: "Sub Account", type: "string", required: false }
      ]
    },
    supportsLabelGeneration: true,
    supportsPickupRequest: true,
    products: [
      { code: "chronopost-18", isPickupPoint: false, name: "Chronopost 18", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "18", international: "17" }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 4, padding: 2 } } },
      { code: "chronopost-13", isPickupPoint: false, name: "Chronopost 13", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "13", international: "17" }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 4, padding: 2 } } },
      { code: "relais", isPickupPoint: true, name: "Chrono Relais", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "44" }, servedZones: ["FR_METRO"], zoneDelays: { EU: { promise: 3, padding: 2 } } },
      { code: "shop2shop", isPickupPoint: true, name: "Shop2Shop", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "2R" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_lendemain_13h", isPickupPoint: false, name: "Lendemain avant 13h", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "13", international: "17" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_lendemain_18h", isPickupPoint: false, name: "Livraison le lendemain avant 18h", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "18", international: "17" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_jour_j", isPickupPoint: false, name: "Livraison le jour m\xEAme", defaultSmartDelivery: { defaultPromise: 0, defaultPadding: 0, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "SD" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_relais_france", isPickupPoint: true, name: "Livraison en relais France", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "44" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_rapide_eco", isPickupPoint: false, name: "Livraison rapide et \xE9conomique vers l'Europe", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "16", international: "16" }, servedZones: ["EU"] },
      { code: "chronopost_express_world", isPickupPoint: false, name: "Livraison Express Monde", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "17", international: "17" }, servedZones: ["EU", "MONDE"], zoneDelays: { MONDE: { promise: 4, padding: 2 } } },
      { code: "chronopost_relais_europe_outre_mer", isPickupPoint: true, name: "Livraison en relais Europe et Outre-Mer", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "49", international: "49" }, servedZones: ["EU", "OM1", "OM2"], zoneDelays: { OM2: { promise: 6, padding: 2 } } },
      { code: "chronopost_shop2shop", isPickupPoint: true, name: "Shop2Shop", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "2R" }, servedZones: ["FR_METRO"] },
      { code: "chronopost_2shopdirect", isPickupPoint: true, name: "2Shop Direct", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, carrierProductCodes: { default: "T2" }, servedZones: ["FR_METRO"], zoneDelays: { EU: { promise: 4, padding: 2 } } }
    ]
  },
  dhl: {
    name: "DHL",
    logo: "dhl.png",
    match: (code) => code === "dhl" || code.includes("dhl-express") || code.includes("dhlexpress") || code.includes("dhl-economy") || code.includes("dhleconomy") || code.includes("dhl-tax-free") || code.includes("dhltaxfree"),
    tracking: { provider: "native", trackingMoreCarrierCode: "dhl" },
    trackingUrl: {
      url: "https://www.dhl.com/{countryCode}/home/tracking.html?tracking-id={trackingId}",
      fallbackUrl: "https://www.dhl.com/fr-fr/home/tracking.html",
      supportsLocale: true,
      formatCountryCode: (countryCode, locale) => `${countryCode.toLowerCase()}-${locale}`
    },
    matchTrackingNumber: (tn) => /^JJD\d{10,}$/i.test(tn),
    meta: {
      trackingMethod: "API officielle DHL Shipment Tracking - Unified (cl\xE9 API par boutique), sinon scraper",
      notes: "Quota par cl\xE9, accord\xE9 par DHL au marchand."
    },
    credentials: {
      // Tracking uses the merchant's own DHL Shipment Tracking API key; labels use
      // their MyDHL API (Express) credentials. Either can be configured alone.
      usedFor: ["tracking", "shipment"],
      supportsCredentialCheck: true,
      fields: [
        { key: "trackingApiKey", label: "API Key (DHL Shipment Tracking)", type: "string", required: true, sensitive: true, usedFor: ["tracking"] },
        { key: "webSiteId", label: "Web Site ID (MyDHL API)", type: "string", required: true, usedFor: ["shipment"] },
        { key: "securityKey", label: "Security Key (MyDHL API)", type: "string", required: true, sensitive: true, usedFor: ["shipment"] },
        { key: "shipperAccountNumber", label: "Num\xE9ro de compte exp\xE9diteur", type: "string", required: true, usedFor: ["shipment"] },
        { key: "eori", label: "Num\xE9ro EORI", type: "string", required: false, usedFor: ["shipment"] },
        { key: "incoterm", label: "Incoterm (DAP ou DDP, d\xE9faut DAP)", type: "string", required: false, usedFor: ["shipment"] }
      ]
    },
    // Génération d'étiquettes DHL Express (MyDHL API). V1 : destinations UE +
    // national uniquement (isCustomsDeclarable = false) — le hors-UE exige une
    // déclaration douanière (lignes produits) que la page de création manuelle
    // ne fournit pas encore.
    supportsLabelGeneration: true,
    products: [
      // carrierProductCodes drives MyDHL API label generation.
      // Express family → `N` (national) / `U` (UE) / `P` (international) ;
      // Economy → `W` (UE) / `H` (international). Le hors-UE construit une
      // déclaration douanière (voir dhl-customs.resolver.ts).
      // Products without codes (e.g. dhl_service_point) are not label-capable.
      { code: "dhl", isPickupPoint: false, name: "DHL", carrierProductCodes: { national: "N", eu: "U", international: "P" }, defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 3, padding: 1 } } },
      { code: "dhl-express", isPickupPoint: false, name: "DHL Express", carrierProductCodes: { national: "N", eu: "U", international: "P" }, defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 4, padding: 2 } } },
      { code: "dhl_express_worldwide", isPickupPoint: false, name: "DHL Express Worldwide", carrierProductCodes: { national: "N", eu: "U", international: "P" }, defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU", "MONDE"], zoneDelays: { EU: { promise: 1, padding: 1 }, MONDE: { promise: 3, padding: 1 } } },
      { code: "dhl_express_domestic", isPickupPoint: false, name: "DHL Express Domestic", carrierProductCodes: { national: "N", eu: "U", international: "P" }, defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO"] },
      { code: "dhl_economy_select", isPickupPoint: false, name: "DHL Economy Select", carrierProductCodes: { default: "W", international: "H" }, defaultSmartDelivery: { defaultPromise: 5, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU", "MONDE"], zoneDelays: { EU: { promise: 3, padding: 1 }, MONDE: { promise: 7, padding: 2 } } },
      { code: "dhl_euroconnect", isPickupPoint: false, name: "DHL Euroconnect", carrierProductCodes: { default: "W", international: "H" }, defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "dhl_parcel_europe", isPickupPoint: false, name: "DHL Parcel Europe", carrierProductCodes: { default: "W", international: "H" }, defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "dhl_parcel_connect", isPickupPoint: false, name: "DHL Parcel Connect", carrierProductCodes: { default: "W", international: "H" }, defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "dhl_service_point", isPickupPoint: true, name: "DHL ServicePoint", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"] }
    ]
  },
  ups: {
    name: "UPS",
    logo: "ups.png",
    match: (code) => code === "ups" || code.includes("ups-standard") || code.includes("upsstandard") || code.includes("ups-saver") || code.includes("upssaver") || code.includes("ups-ground") || code.includes("upsground"),
    tracking: { provider: "native", trackingMoreCarrierCode: "ups" },
    trackingUrl: {
      url: "https://www.ups.com/track?loc={locale}&tracknum={trackingId}",
      fallbackUrl: "https://www.ups.com/track",
      supportsLocale: true,
      formatLocale: (locale) => `${locale}_${locale.toUpperCase()}`
    },
    matchTrackingNumber: (tn) => /^1Z[0-9A-Z]{16}$/i.test(tn),
    meta: {
      trackingMethod: "API officielle UPS Tracking (OAuth2)"
    },
    credentials: {
      usedFor: ["tracking", "shipment"],
      oauth: true,
      supportsCredentialCheck: true,
      fields: [
        { key: "accountNumber", label: "Account Number", type: "string", required: true }
      ]
    },
    supportsLabelGeneration: true,
    products: [
      // MONDE mesuré par destination : US n=198 méd. 3 p80 6, CA n=45 méd. 3, AU n=30 méd. 3.
      { code: "standard", isPickupPoint: false, name: "UPS Standard", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 3, padding: 3 } } },
      { code: "saver", isPickupPoint: false, name: "UPS Saver", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 4, padding: 2 } } },
      // Même produit physique que `standard` ci-dessus (même nom) : valeurs alignées,
      // sinon deux marchands reçoivent des EDD écartées de 3 jours selon le code
      // posé à l'onboarding.
      { code: "ups_standard", isPickupPoint: false, name: "UPS Standard", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "11" }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 3, padding: 3 } } },
      { code: "ups_express", isPickupPoint: false, name: "UPS Express", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "07" }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 3, padding: 2 } } },
      { code: "ups_express_saver", isPickupPoint: false, name: "UPS Express Saver", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "65" }, servedZones: ["FR_METRO", "EU", "MONDE"], zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 4, padding: 2 } } },
      { code: "ups_access_point", isPickupPoint: true, name: "UPS Access Point", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["FR_METRO", "EU"] },
      { code: "ups_expedited", isPickupPoint: false, name: "UPS Expedited", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, carrierProductCodes: { default: "08" }, servedZones: ["EU", "MONDE"], zoneDelays: { MONDE: { promise: 6, padding: 2 } } }
    ]
  },
  gls: {
    name: "GLS",
    logo: "gls.png",
    match: (code) => code === "gls",
    tracking: { provider: "native", trackingMoreCarrierCode: "gls" },
    trackingUrl: {
      url: "https://gls-group.com/GROUP/en/parcel-tracking?match={trackingId}",
      fallbackUrl: "https://gls-group.com/GROUP/en/parcel-tracking"
    },
    meta: {
      trackingMethod: "API publique non-authentifi\xE9e (gls-group.com)",
      notes: "Deux endpoints : rstt029 (overview) puis rstt028 (d\xE9tail si code postal disponible)."
    },
    products: [
      { code: "gls", isPickupPoint: false, name: "GLS Standard", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 3, padding: 2 } } },
      { code: "gls-point-relais", isPickupPoint: true, name: "GLS Point Relais", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } },
      { code: "gls_business_parcel", isPickupPoint: false, name: "GLS Business Parcel", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5, padding: 2 } } },
      { code: "gls_europlus", isPickupPoint: false, name: "GLS EuroPlus", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      // FR n=364 méd. 2 p80 3 ; ES n=64 méd. 3 p80 4 ; DE n=53 méd. 4 p80 4.
      { code: "gls_shop_delivery", isPickupPoint: true, name: "GLS Shop Delivery", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 3, padding: 2 } } },
      { code: "gls_parcel_shop", isPickupPoint: true, name: "GLS ParcelShop", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } }
    ]
  },
  "mondial-relay": {
    name: "Mondial Relay",
    logo: "mondial-relay.png",
    match: (code) => code === "mondial-relay" || code === "mondialrelay",
    tracking: { provider: "native", trackingMoreCarrierCode: "mondialrelay" },
    trackingUrl: {
      url: "https://www.mondialrelay.fr/suivi-de-colis?NumeroExpedition={trackingId}&CodePostal={zipCode}",
      fallbackUrl: "https://www.mondialrelay.fr/suivi-de-colis",
      requiredFields: ["zipCode"]
    },
    meta: {
      trackingMethod: "API web mondialrelay.fr (via proxy SmartProxy)",
      notes: "Authentification par cookie obtenu via scraping. N\xE9cessite proxy r\xE9sidentiel FR."
    },
    credentials: {
      // The labels Connect API `CustomerId` is the `brand`, hence a field
      // shared by both usages.
      usedFor: ["tracking", "shipment"],
      fields: [
        { key: "brand", label: "Enseigne (Brand / CustomerId)", type: "string", required: true },
        { key: "securityKey", label: "Security Key", type: "string", required: true, sensitive: true, usedFor: ["tracking"] },
        { key: "login", label: "Login Connect API", type: "string", required: true, usedFor: ["shipment"] },
        { key: "password", label: "Password Connect API", type: "string", required: true, sensitive: true, usedFor: ["shipment"] }
      ],
      supportsCredentialCheck: true
    },
    // Génération d'étiquettes Mondial Relay (Connect API). V1 : point relais
    // uniquement (mode `24R`). Le code du point relais est résolu depuis la
    // commande via `pickupPointCartAttributes` puis passé à la stratégie.
    supportsLabelGeneration: true,
    // Known cart customAttribute conventions for MR pickup points:
    // - `Mondial_Relay_*` (Bellerose / Checkout Blocks integrations)
    // - `PickupPoint*` (Globe app / generic). Note: `PickupPointCourier` is
    //   misnamed by the Globe app — it actually carries an ISO country code
    //   (e.g. "FR", "BE"), not a carrier identifier.
    // - `mondial_relay_*` (SmartDelivery / intégrations checkout maison).
    pickupPointCartAttributes: {
      id: ["Mondial_Relay_CODE", "PickupPointId", "mondial_relay_id"],
      zip: ["Mondial_Relay_ZIP_CODE", "PickupPointPostCode", "mondial_relay_zip"],
      name: ["Mondial_Relay_NAME", "PickupPointName", "PickupPointPlace", "mondial_relay_name"],
      address1: ["Mondial_Relay_ADDRESS_1", "PickupPointAddress", "mondial_relay_address"],
      city: ["Mondial_Relay_CITY", "PickupPointCity", "mondial_relay_city"],
      country: ["Mondial_Relay_COUNTRY", "PickupPointCourier", "mondial_relay_country"]
    },
    // 98 % of Mondial Relay parcels are measured as pickup deliveries, so an
    // opaque label like `MREL_SE` must not default to home.
    defaultProductCode: "mondial-relay",
    products: [
      // Même produit physique que `mondial_relay_point_relais` (même nom) : EU aligné
      // sur la mesure (n=606, méd. 3).
      { code: "mondial-relay", isPickupPoint: true, name: "Mondial Relay Point Relais", carrierProductCodes: { default: "24R" }, defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 3 } } },
      { code: "mondial-relay-home", isPickupPoint: false, name: "Mondial Relay Domicile", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } },
      { code: "mondial_relay_point_relais", isPickupPoint: true, name: "Mondial Relay Point Relais", carrierProductCodes: { default: "24R" }, defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 3 } } },
      // Relais transfrontalier, bien plus rapide que le relais domestique : 93 % du
      // volume est Belgique. Mesuré sur 884 colis livrés (120 j) : EU n=611 méd. 1,5
      // P90 4,5 ; FR n=273 méd. 1,5 P90 4,5. Les deux zones donnent la même paire,
      // d'où l'absence de `zoneDelays`. Servi (avec le supplément de repli) 1 à 5 j,
      // contre 3 à 7 avant cette entrée, ce qui livrait 91 % des colis AVANT l'edd_min.
      { code: "mondial_relay_point_relais_international", isPickupPoint: true, name: "Mondial Relay Point Relais International", carrierProductCodes: { default: "24R" }, defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 2, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"] },
      { code: "mondial_relay_domicile", isPickupPoint: false, name: "Mondial Relay Domicile", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } },
      { code: "mondial_relay_xl", isPickupPoint: false, name: "Mondial Relay XL", defaultSmartDelivery: { defaultPromise: 4, defaultPadding: 1, deliveryDays: MONDIAL_DAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 6 } } }
    ]
  },
  fedex: {
    name: "FedEx",
    logo: "fedex.png",
    match: (code) => code === "fedex",
    tracking: { provider: "native", trackingMoreCarrierCode: "fedex" },
    trackingUrl: {
      url: "https://www.fedex.com/fedextrack/?trknbr={trackingId}",
      fallbackUrl: "https://www.fedex.com/fedextrack/"
    },
    meta: {
      trackingMethod: "API officielle FedEx Track (OAuth2)"
    },
    credentials: {
      usedFor: ["tracking"],
      fields: [
        { key: "clientId", label: "Client ID", type: "string", required: true },
        { key: "clientSecret", label: "Client Secret", type: "string", required: true, sensitive: true },
        { key: "accountNumber", label: "Account Number", type: "string", required: true }
      ],
      supportsCredentialCheck: true
    },
    products: [
      { code: "fedex", isPickupPoint: false, name: "FedEx Standard", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"] },
      { code: "fedex_international_priority", isPickupPoint: false, name: "FedEx International Priority", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU", "MONDE"] },
      { code: "fedex_international_economy", isPickupPoint: false, name: "FedEx International Economy", defaultSmartDelivery: { defaultPromise: 5, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU", "MONDE"] },
      { code: "fedex_ground", isPickupPoint: false, name: "FedEx Ground", defaultSmartDelivery: { defaultPromise: 5, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"] },
      { code: "fedex_express_saver", isPickupPoint: false, name: "FedEx Express Saver", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"] }
    ]
  },
  "global-e": {
    name: "Global-E",
    match: (code) => code === "global-e" || code === "globale",
    tracking: { provider: "native" },
    trackingUrl: {
      url: "https://www.global-e.com/Tracking/Tracking?orderid={trackingId}&CountryCode={countryCode}",
      fallbackUrl: "https://www.global-e.com/Tracking/Tracking",
      requiredFields: ["countryCode"],
      supportsLocale: true,
      formatCountryCode: (countryCode, locale) => `${countryCode.toLowerCase()}-${locale}`
    },
    meta: {
      trackingMethod: "API officielle Global-E (SDK client)",
      notes: "Utilise le package @global-e/client. Fallback vers TrackShip si configur\xE9."
    },
    credentials: {
      usedFor: ["tracking"],
      fields: [
        { key: "account", label: "Merchant GUID", type: "string", required: true }
      ],
      supportsCredentialCheck: true
    },
    // `ShipperName` from the Global-e API, stored as `carrierDisplayName`. This is
    // Global-e's whole vocabulary: 7 values over a year of production, 5 once the
    // "api" channel variant is normalized away. Unknown values are logged.
    sourceProductMap: {
      "dhl express worldwide": { carrier: "dhl", product: "dhl_express_worldwide" },
      // No exact code for the road offering: `dhl_euroconnect` (promise 3) matches
      // the measured 3-day median, `dhl_economy_select` (promise 5) does not.
      "dhl european road economy": { carrier: "dhl", product: "dhl_euroconnect" },
      "dhl european road": { carrier: "dhl", product: "dhl_euroconnect" },
      "fedex ficp worldwide": { carrier: "fedex", product: "fedex_international_priority" },
      "chronopost standard": { carrier: "chronopost", product: "chronopost-13" }
    },
    products: [
      { code: "global-e", isPickupPoint: false, name: "Global-E", defaultSmartDelivery: { defaultPromise: 5, defaultPadding: 1, deliveryDays: WEEKDAYS }, zoneDelays: { EU: { promise: 2 }, MONDE: { promise: 3 } }, servedZones: ["EU", "OM1", "OM2", "MONDE"] }
    ]
  },
  bpost: {
    name: "bpost",
    logo: "bpost.png",
    match: (code) => code === "bpost" || code === "bepost" || code === "be-post",
    tracking: { provider: "native", trackingMoreCarrierCode: "belgium-post" },
    trackingUrl: {
      url: "https://track.bpost.cloud/btr/web/#/search?itemCode={trackingId}",
      fallbackUrl: "https://track.bpost.cloud/btr/web/"
    },
    meta: {
      trackingMethod: "API publique non-authentifi\xE9e (track.bpost.cloud)"
    },
    products: [
      // Belgian national operator, not a global integrator: the whole parcel
      // history is 100% Belgium (n=13499 on 2026-09-03, zero FR, zero outside
      // Europe) and the shipping shops route every non-BE destination to a
      // dedicated carrier. Same footprint as its peers (postnl, swiss-post,
      // hermes-de), and the same as the pickup product below, which this used
      // to contradict.
      // The FR_METRO / MONDE zoneDelays below are live, not hypothetical: one
      // shop stores servedZones ["FR_METRO","EU","MONDE"] today and
      // `getRegistryTransit` reads zoneDelays independently of servedZones, so
      // both entries serve production transit right now. Do not drop them as
      // dead data.
      { code: "bpost", isPickupPoint: false, name: "bpost", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"], zoneDelays: { FR_METRO: { promise: 3 }, MONDE: { promise: 8, padding: 2 } } },
      { code: "bpost-point-relais", isPickupPoint: true, name: "bpost Point Relais", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  custom: {
    name: "Custom",
    match: (code) => code === "custom",
    tracking: { provider: "manual" },
    trackingUrl: { url: null },
    meta: {
      trackingMethod: "Manuel (API emitParcelStatus ou back-office)"
    },
    products: []
  },
  dpd: {
    name: "DPD",
    match: (code) => code === "dpd" || code === "fake-dpd",
    tracking: { provider: "native", trackingMoreCarrierCode: "dpd" },
    trackingUrl: {
      url: "https://trace.dpd.fr/fr/trace/{trackingId}",
      fallbackUrl: "https://trace.dpd.fr/fr/trace"
    },
    credentials: {
      usedFor: ["tracking", "shipment"],
      // DPD only answers tracking/shipment API calls coming from whitelisted IPs.
      ipWhitelist: ["171.33.105.206", "171.33.92.211"],
      fields: [
        { key: "userid", label: "User ID", type: "string", required: true },
        { key: "password", label: "Password", type: "string", required: true, sensitive: true },
        { key: "customerCountryCode", label: "Customer Country Code", type: "string", required: true },
        { key: "customerCenterNumber", label: "Customer Center Number", type: "string", required: true },
        { key: "customerNumber", label: "Customer Number", type: "string", required: true }
      ],
      supportsCredentialCheck: true
    },
    products: [
      // EU : mesure instable selon la fenêtre (3+2 sur 120 j, 5+1 sur 90 j), on retient la plus large.
      { code: "dpd", isPickupPoint: false, name: "DPD Standard", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 3, padding: 2 } } },
      { code: "dpd-pickup", isPickupPoint: true, name: "DPD Pickup", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["FR_METRO", "EU"], zoneDelays: { EU: { promise: 5 } } }
    ]
  },
  "dpd-uk": {
    name: "DPD UK",
    match: (code) => code === "dpd-uk" || code === "dpducluk" || code === "dpd-ucl-uk",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "dpd-uk" },
    trackingUrl: {
      url: "https://www.dpd.co.uk/service/tracking?consignment={trackingId}",
      fallbackUrl: "https://www.dpd.co.uk/service/tracking"
    },
    products: [
      { code: "dpd-uk", isPickupPoint: false, name: "DPD UK", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "dpd-uk-pickup", isPickupPoint: true, name: "DPD UK Pickup", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  tnt: {
    name: "TNT",
    match: (code) => code === "tnt",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "tnt" },
    trackingUrl: {
      url: "https://www.tnt.com/express/{locale}/site/shipping-tools/tracking.html?searchType=con&cons={trackingId}",
      fallbackUrl: "https://www.tnt.com/express/fr_fr/site/shipping-tools/tracking.html",
      supportsLocale: true,
      formatLocale: (locale) => `${locale}_${locale}`
    },
    products: [
      { code: "tnt", isPickupPoint: false, name: "TNT", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU", "MONDE"] }
    ]
  },
  canadapost: {
    name: "Canada Post",
    match: (code) => code === "canadapost" || code === "canada-post",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "canada-post" },
    trackingUrl: {
      url: "https://www.canadapost-postescanada.ca/track-reperage/{locale}#/details/{trackingId}",
      fallbackUrl: "https://www.canadapost-postescanada.ca/track-reperage/en",
      supportsLocale: true
    },
    products: [
      { code: "canadapost", isPickupPoint: false, name: "Canada Post", defaultSmartDelivery: { defaultPromise: 5, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["MONDE"] }
    ]
  },
  geodis: {
    name: "Geodis",
    logo: "geodis.png",
    match: (code) => code === "geodis",
    tracking: { provider: "native", trackingMoreCarrierCode: "geodis" },
    trackingUrl: {
      url: "https://espace-client.geodis.com/services/destinataires/#/en/suivi/{trackingId}"
    },
    meta: {
      trackingMethod: "API publique non-authentifi\xE9e (endpoint anonyme destinataire)",
      notes: "HMAC-SHA256 avec appKey hardcod\xE9e. Derri\xE8re Cloudflare Bot Management \u2014 risque 403 sur volume \xE9lev\xE9."
    },
    products: [
      { code: "geodis", isPickupPoint: false, name: "Geodis", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO", "EU"] }
    ]
  },
  "colis-prive": {
    name: "Colis Priv\xE9",
    match: (code) => code === "colis-prive" || code === "colisprive",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "colis-prive" },
    trackingUrl: {
      url: "https://www.colisprive.com/moncolis/pages/detailColis.aspx?numColis={trackingId}&cp={zipCode}",
      fallbackUrl: "https://www.colisprive.com/moncolis/",
      requiredFields: ["zipCode"]
    },
    products: [
      { code: "colis-prive", isPickupPoint: false, name: "Colis Priv\xE9", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["FR_METRO"] }
    ]
  },
  seur: {
    name: "SEUR",
    match: (code) => code === "seur",
    tracking: { provider: "native", trackingMoreCarrierCode: "international-seur" },
    trackingUrl: {
      url: "https://www.seur.com/livetracking/?segOnlineIdentifier={trackingId}",
      fallbackUrl: "https://www.seur.com/livetracking/"
    },
    meta: {
      trackingMethod: "API officielle SEUR PIC (OAuth2 password grant)",
      notes: "Token obtenu via POST pic_token avec client_id/client_secret + username/password.",
      limitations: "Adresse du point relais non r\xE9cup\xE9rable. Sur une livraison redirig\xE9e en point relais (destinataire absent \u2192 codes LJ105/LI574\u2026), l'API PIC ne renvoie que le CP/ville de destination + les codes d'\xE9v\xE9nements, jamais l'adresse du point. Cette adresse n'existe que sur la page de suivi client (endpoint consultarEnvioLT, derri\xE8re Imperva Incapsula \u2192 non exploitable en server-to-server). Cons\xE9quence : l'email de mise \xE0 disposition ne peut afficher que l'adresse de destination d'origine, pas celle du point relais. Aucune solution tant que SEUR n'expose pas le pudo dans l'API PIC."
    },
    credentials: {
      usedFor: ["tracking"],
      fields: [
        { key: "clientId", label: "Client ID", type: "string", required: true },
        { key: "clientSecret", label: "Client Secret", type: "string", required: true, sensitive: true },
        { key: "username", label: "Username", type: "string", required: true },
        { key: "password", label: "Password", type: "string", required: true, sensitive: true },
        { key: "accountNumber", label: "Account Number", type: "string", required: true },
        { key: "businessUnit", label: "Business Unit", type: "string", required: true },
        { key: "idNumber", label: "ID Number (NIF)", type: "string", required: true }
      ],
      supportsCredentialCheck: true
    },
    products: [
      { code: "seur", isPickupPoint: false, name: "SEUR", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "seur_24", isPickupPoint: false, name: "SEUR 24", defaultSmartDelivery: { defaultPromise: 1, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "seur_pickup", isPickupPoint: true, name: "SEUR Pickup", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  hermes: {
    name: "Hermes",
    match: (code) => code === "hermes",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "hermes" },
    trackingUrl: {
      url: "https://www.myhermes.de/empfangen/sendungsverfolgung/sendungsinformation/#/{trackingId}",
      fallbackUrl: "https://www.myhermes.de/empfangen/sendungsverfolgung/"
    },
    products: [
      { code: "hermes", isPickupPoint: false, name: "Hermes", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] },
      { code: "hermes-pickup", isPickupPoint: true, name: "Hermes ParcelShop", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  "hermes-de": {
    name: "Hermes Germany",
    match: (code) => code === "hermes-de" || code === "hermesde",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "hermes-de" },
    trackingUrl: {
      url: "https://www.myhermes.de/empfangen/sendungsverfolgung/sendungsinformation/#/{trackingId}",
      fallbackUrl: "https://www.myhermes.de/empfangen/sendungsverfolgung/"
    },
    products: [
      { code: "hermes-de", isPickupPoint: false, name: "Hermes Germany", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] },
      { code: "hermes-de-pickup", isPickupPoint: true, name: "Hermes Germany PaketShop", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  "hermes-uk": {
    name: "Hermes UK (Evri)",
    match: (code) => code === "hermes-uk" || code === "hermesuk" || code === "evri",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "hermes-uk" },
    trackingUrl: {
      url: "https://www.evri.com/track-a-parcel/{trackingId}",
      fallbackUrl: "https://www.evri.com/track-a-parcel"
    },
    products: [
      { code: "hermes-uk", isPickupPoint: false, name: "Hermes UK (Evri)", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] },
      { code: "hermes-uk-pickup", isPickupPoint: true, name: "Evri ParcelShop", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  "swiss-post": {
    name: "Swiss Post",
    logo: "swiss-post.png",
    match: (code) => code === "swiss-post" || code === "swisspost",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "swiss-post" },
    trackingUrl: {
      url: "https://service.post.ch/ekp-web/ui/entry/search/{trackingId}",
      fallbackUrl: "https://www.swisspost.ch/swisspost-tracking"
    },
    meta: {
      trackingMethod: "Via TrackingMore (API universelle)",
      notes: "Impl\xE9mentation API native (developer.post.ch OAuth2) \xE0 pr\xE9voir pour volume \xE9lev\xE9."
    },
    products: [
      { code: "swiss-post", isPickupPoint: false, name: "Swiss Post", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] },
      { code: "swiss-post-pickup", isPickupPoint: true, name: "Swiss Post Pickup", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  postnl: {
    name: "PostNL",
    logo: "postnl.png",
    match: (code) => code === "postnl" || code === "post-nl" || code === "post_nl",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "postnl-3s" },
    trackingUrl: {
      url: "https://jouw.postnl.nl/track-and-trace/{trackingId}/{countryCode}/{zipCode}",
      fallbackUrl: "https://jouw.postnl.nl/track-and-trace/",
      requiredFields: ["zipCode", "countryCode"]
    },
    meta: {
      trackingMethod: "Via TrackingMore (API universelle)",
      notes: "Impl\xE9mentation API native (developer.postnl.nl \u2014 Shipping Status) possible plus tard avec credentials par shop (customercode + customernumber + API key via Mijn PostNL Zakelijk), m\xEAme mod\xE8le que UPS/FedEx."
    },
    products: [
      { code: "postnl", isPickupPoint: false, name: "PostNL", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] },
      { code: "postnl-pickup", isPickupPoint: true, name: "PostNL Pakketpunt", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  sending: {
    name: "Sending",
    logo: "sending.png",
    match: (code) => code === "sending" || code === "sending-es",
    tracking: { provider: "tracking-more", trackingMoreCarrierCode: "sending" },
    trackingUrl: {
      url: null,
      fallbackUrl: "https://www.sending.es/en/find-your-shipment/"
    },
    meta: {
      trackingMethod: "Via TrackingMore (API universelle)",
      notes: "Sending Transporte Urgente \u2014 transporteur espagnol (ES/PT/Andorre/Canaries/Bal\xE9ares). Pas de developer portal public ; API native en contrat B2B direct uniquement."
    },
    products: [
      { code: "sending", isPickupPoint: false, name: "Sending", defaultSmartDelivery: { defaultPromise: 2, defaultPadding: 1, deliveryDays: WEEKDAYS }, servedZones: ["EU"] },
      { code: "sending-pickup", isPickupPoint: true, name: "Sending Pickup", defaultSmartDelivery: { defaultPromise: 3, defaultPadding: 1, deliveryDays: WEEKDAYS_SAT }, servedZones: ["EU"] }
    ]
  },
  // Carriers with tracking URL only (no tracking provider in our system)
  "australia-post": {
    name: "Australia Post",
    match: (code) => code === "australia-post" || code === "australiapost",
    tracking: { provider: "none" },
    trackingUrl: {
      url: "https://auspost.com.au/track/track-details?id={trackingId}",
      fallbackUrl: "https://auspost.com.au/track/"
    },
    products: []
  },
  // Carriers with no tracking URL
  "la-poste": {
    name: "La Poste",
    match: () => false,
    tracking: { provider: "none" },
    products: []
  },
  "customer-carrier": {
    name: "Customer Carrier",
    match: (code) => code === "customer-carrier",
    tracking: { provider: "none" },
    products: []
  },
  "merchant-carrier": {
    name: "Merchant Carrier",
    match: (code) => code === "merchant-carrier",
    tracking: { provider: "none" },
    products: []
  },
  logfret: {
    name: "LogFret",
    match: (code) => code === "logfret",
    tracking: { provider: "none" },
    products: []
  },
  crosslog: {
    name: "Crosslog",
    match: (code) => code === "crosslog",
    tracking: { provider: "none" },
    products: []
  },
  malca: {
    name: "Malca",
    match: (code) => code === "malca",
    tracking: { provider: "none" },
    products: []
  },
  envoidunet: {
    name: "EnvoiDunet",
    match: (code) => code === "envoidunet",
    tracking: { provider: "none" },
    products: []
  },
  bleckmann: {
    name: "Bleckmann",
    match: (code) => code === "bleckmann",
    tracking: { provider: "none" },
    products: []
  },
  sympl: {
    name: "Sympl",
    match: (code) => code === "sympl",
    tracking: { provider: "none" },
    products: []
  },
  "api-carrier": {
    name: "API Carrier",
    match: (code) => code === "api-carrier",
    tracking: { provider: "none" },
    products: []
  }
};
var registryEntries = Object.entries(CARRIER_REGISTRY);
function getDefinition(code) {
  return CARRIER_REGISTRY[code];
}
var SUPPORTED_TRACKING_CARRIERS = registryEntries.filter(([, def]) => def.tracking.provider !== "none").map(([code]) => code);
var VARIANT_NAMES = {
  "la-poste-colissimo": "Colissimo",
  "colissimo/colissimo-livraison-a-domicile-avec-signature": "Colissimo",
  colissimov2: "Colissimo",
  "chronopost-18": "Chronopost 18",
  "chrono-relais": "Chrono Relais",
  "chrono-shop2shop": "Chrono Shop2Shop",
  "fake-dpd": "Fake DPD",
  dpdUclUk: "DPD UCL UK",
  "dhl-express": "DHL Express",
  "dhl-economy-select": "DHL Economy Select",
  "dhl-tax-free": "DHL Tax Free",
  "ups-standard": "UPS Standard",
  "ups-saver": "UPS Saver",
  "ups-ground": "UPS Ground"
};
var CARRIERS_NAMES = {
  ...Object.fromEntries(registryEntries.map(([code, def]) => [code, def.name])),
  ...VARIANT_NAMES
};

// src/helpers.ts
function mapToCanonicalCarrierCode(carrierCode) {
  const code = carrierCode.toLowerCase();
  for (const [key, def] of registryEntries) {
    if (def.match(code)) {
      return key;
    }
  }
  return null;
}
function getCarrierLabel(code) {
  if (code in CARRIERS_NAMES) return CARRIERS_NAMES[code];
  const canonical = mapToCanonicalCarrierCode(code);
  if (canonical) return getDefinition(canonical).name;
  return code;
}
var NON_BRAND_CARRIER_CODES = /* @__PURE__ */ new Set([
  "custom",
  "customer-carrier",
  "merchant-carrier",
  "api-carrier"
]);
var CARRIER_BRANDS = registryEntries.filter(([code]) => !NON_BRAND_CARRIER_CODES.has(code)).map(([, def]) => ({
  name: def.name,
  needle: `-${normalizeShippingLine(def.name)}-`
})).sort((a, b) => b.needle.length - a.needle.length);
function resolveCarrierBrand(carrierDisplayName, carrierCode) {
  const displayName = carrierDisplayName?.trim();
  if (displayName) {
    const normalized = `-${normalizeShippingLine(displayName)}-`;
    const brand = CARRIER_BRANDS.find(
      ({ needle }) => normalized.includes(needle)
    );
    return brand?.name ?? displayName;
  }
  const canonical = mapToCanonicalCarrierCode(carrierCode);
  return canonical ? getDefinition(canonical).name : carrierCode;
}
function getCarrierLogoFilename(code) {
  const canonical = mapToCanonicalCarrierCode(code);
  if (canonical) return getDefinition(canonical).logo ?? null;
  return null;
}
function isSupportedTrackingCarrier(carrierCode) {
  return SUPPORTED_TRACKING_CARRIERS.includes(carrierCode);
}
function isNativeCarrier(carrierCode) {
  if (!(carrierCode in CARRIER_REGISTRY)) return false;
  return getDefinition(carrierCode).tracking.provider === "native";
}
function isTrackingMoreCarrier(carrierCode) {
  if (!(carrierCode in CARRIER_REGISTRY)) return false;
  return getDefinition(carrierCode).tracking.provider === "tracking-more";
}
function getTrackingMoreCarrierCode(carrierCode) {
  if (!(carrierCode in CARRIER_REGISTRY)) return void 0;
  return getDefinition(carrierCode).tracking.trackingMoreCarrierCode;
}
function getCarrierProducts(carrierCode) {
  if (!(carrierCode in CARRIER_REGISTRY)) return [];
  return [...getDefinition(carrierCode).products];
}
function getProductName(carrierCode, productCode) {
  const products = getCarrierProducts(carrierCode);
  const product = products.find((p) => p.code === productCode);
  return product?.name || productCode;
}
function detectCarrierFromTrackingNumber(trackingNumber) {
  const tn = trackingNumber.trim();
  for (const [key, def] of registryEntries) {
    if (def.matchTrackingNumber?.(tn)) {
      return key;
    }
  }
  return null;
}
var MULTI_PART_TLDS = /* @__PURE__ */ new Set(["co.uk", "com.au", "co.nz", "co.jp", "com.br"]);
function getRegistrableDomain(hostname) {
  const parts = hostname.toLowerCase().replace(/\.$/, "").split(".").filter(Boolean);
  if (parts.length <= 2) return parts.join(".");
  const lastTwo = parts.slice(-2).join(".");
  return MULTI_PART_TLDS.has(lastTwo) ? parts.slice(-3).join(".") : lastTwo;
}
function getUrlRegistrableDomain(url) {
  try {
    return getRegistrableDomain(new URL(url).hostname);
  } catch {
    return null;
  }
}
var TRACKING_URL_DOMAIN_OVERRIDES = {
  "colissimo.fr": "colissimo",
  // The registry only knows `tnt.com`, but some 3PLs (e.g. FAGUO) push TNT
  // fulfillments with a `tnt.fr` tracking URL and a generic `tracking_company`.
  "tnt.fr": "tnt",
  // DHL spreads its tracking over several hosts the registry doesn't declare
  // (it only knows `dhl.com`). Seen in production with an unmappable
  // `tracking_company`:
  //   logistics.dhl      — DHL eCommerce/Parcel portal, Global-E final mile
  //                        labelled "InHouse" (Gerard Darel)
  //   express.dhl        — mydhl.express.dhl, same Global-E orders
  //   dhlglobalmail.com  — DHL Global Mail, labelled "DHL eCommerce" (FAGUO)
  //
  // `.dhl` is a brand gTLD owned by Deutsche Post DHL, so a suffix rule on the
  // TLD would cover every future host in one line. We keep the allow-list on
  // purpose: it bounds what we claim to domains we have actually observed, and
  // half the DHL estate (`dhl.de`, `dhlparcel.nl`, `dhlglobalmail.com`) sits
  // outside the brand TLD anyway, so the rule would not remove the list. Add
  // the next host here rather than generalising.
  "logistics.dhl": "dhl",
  "express.dhl": "dhl",
  "dhlglobalmail.com": "dhl"
};
var _trackingUrlDomainMap = null;
function getTrackingUrlDomainMap() {
  if (_trackingUrlDomainMap) return _trackingUrlDomainMap;
  const carriersByDomain = /* @__PURE__ */ new Map();
  for (const [key, def] of registryEntries) {
    for (const raw of [def.trackingUrl?.url, def.trackingUrl?.fallbackUrl]) {
      if (!raw) continue;
      const domain = getUrlRegistrableDomain(raw);
      if (!domain) continue;
      const carriers = carriersByDomain.get(domain) ?? /* @__PURE__ */ new Set();
      carriers.add(key);
      carriersByDomain.set(domain, carriers);
    }
  }
  const map = /* @__PURE__ */ new Map();
  for (const [domain, carriers] of carriersByDomain) {
    if (carriers.size === 1) map.set(domain, [...carriers][0]);
  }
  for (const [domain, key] of Object.entries(TRACKING_URL_DOMAIN_OVERRIDES)) {
    map.set(domain, key);
  }
  _trackingUrlDomainMap = map;
  return map;
}
function detectCarrierFromTrackingUrl(url) {
  if (!url) return null;
  const domain = getUrlRegistrableDomain(url);
  if (!domain) return null;
  return getTrackingUrlDomainMap().get(domain) ?? null;
}
function supportsLabelGeneration(carrierCode) {
  if (!(carrierCode in CARRIER_REGISTRY)) return false;
  return getDefinition(carrierCode).supportsLabelGeneration === true;
}
function supportsPickupRequest(carrierCode) {
  if (!(carrierCode in CARRIER_REGISTRY)) return false;
  return getDefinition(carrierCode).supportsPickupRequest === true;
}
function observesPublicHolidays(carrierCode) {
  if (!(carrierCode in CARRIER_REGISTRY)) return true;
  return getDefinition(carrierCode).observesPublicHolidays ?? true;
}
function getAllCarriersWithProducts() {
  return SUPPORTED_TRACKING_CARRIERS.map((carrier) => ({
    carrier,
    products: [...getDefinition(carrier).products]
  })).sort((a, b) => a.carrier.localeCompare(b.carrier));
}
function normalizeShippingLine(input) {
  return input.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}
var PICKUP_LABEL_PATTERN = /\b(relais|points?[-\s]?(de[-\s]?)?retraits?|pickup|relay|locker)\b/i;
var HOME_LABEL_PATTERN = /\b(domicile|home|maison)\b/i;
function matchShippingLineToProductWithSource(carrierCode, shippingLineLabel) {
  const products = getCarrierProducts(carrierCode);
  if (!products.length) return void 0;
  const normalized = normalizeShippingLine(shippingLineLabel);
  if (!normalized) return void 0;
  const codeMatch = products.find(
    (p) => normalizeShippingLine(p.code) === normalized
  );
  if (codeMatch) return { product: codeMatch, source: "code" };
  const spacedShippingLine = normalized.replace(/-/g, " ");
  const isHomeLine = HOME_LABEL_PATTERN.test(spacedShippingLine);
  const isPickupLine = PICKUP_LABEL_PATTERN.test(spacedShippingLine) && !isHomeLine;
  if (isPickupLine) {
    const pickupMatch = products.find((p) => p.isPickupPoint);
    if (pickupMatch) return { product: pickupMatch, source: "keyword" };
  }
  const nameMatches = products.filter((p) => p.name && normalized.includes(normalizeShippingLine(p.name))).sort((a, b) => (b.name?.length ?? 0) - (a.name?.length ?? 0));
  if (nameMatches.length > 0) {
    return { product: nameMatches[0], source: "name" };
  }
  const { defaultProductCode } = getDefinition(carrierCode);
  const declaredDefault = defaultProductCode ? products.find((p) => p.code === defaultProductCode) : void 0;
  const homeProduct = products.find((p) => !p.isPickupPoint);
  if (isHomeLine && homeProduct) {
    return { product: homeProduct, source: "keyword" };
  }
  const fallback = declaredDefault ?? homeProduct;
  return fallback ? { product: fallback, source: "default" } : void 0;
}
function matchShippingLineToProduct(carrierCode, shippingLineCode) {
  return matchShippingLineToProductWithSource(carrierCode, shippingLineCode)?.product;
}
function extractPickupPointFromCartAttributes(carrierCode, customAttributes) {
  if (!customAttributes || customAttributes.length === 0) return void 0;
  const canonical = mapToCanonicalCarrierCode(carrierCode);
  if (!canonical) return void 0;
  const config = getDefinition(canonical).pickupPointCartAttributes;
  if (!config) return void 0;
  const map = /* @__PURE__ */ new Map();
  for (const attr of customAttributes) {
    if (attr?.key && typeof attr.value === "string") {
      map.set(attr.key, attr.value);
    }
  }
  const pick = (candidates) => {
    if (!candidates) return void 0;
    for (const key of candidates) {
      const value = map.get(key)?.trim();
      if (value) return value;
    }
    return void 0;
  };
  const id = pick(config.id);
  const zip = pick(config.zip);
  if (!id || !zip) return void 0;
  return {
    id,
    zip,
    name: pick(config.name),
    address1: pick(config.address1),
    city: pick(config.city),
    country: pick(config.country)
  };
}

// src/zones.ts
var ZONES = ["FR_METRO", "OM1", "OM2", "EU", "MONDE"];
var FR_METRO_COUNTRIES = ["FR", "MC"];
var OM1_COUNTRIES = ["GP", "MQ", "GF", "RE", "YT", "BL", "MF", "PM"];
var OM2_COUNTRIES = ["NC", "PF", "WF", "TF"];
var EU_COUNTRIES = [
  // EU member states (FR is FR_METRO)
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  // EEA + Switzerland + UK + European microstates
  "IS",
  "LI",
  "NO",
  "CH",
  "GB",
  "AD",
  "SM",
  "VA",
  "GI"
];
var COUNTRY_TO_ZONE = {
  ...Object.fromEntries(FR_METRO_COUNTRIES.map((c) => [c, "FR_METRO"])),
  ...Object.fromEntries(OM1_COUNTRIES.map((c) => [c, "OM1"])),
  ...Object.fromEntries(OM2_COUNTRIES.map((c) => [c, "OM2"])),
  ...Object.fromEntries(EU_COUNTRIES.map((c) => [c, "EU"]))
};
function resolveZone(countryCode) {
  return COUNTRY_TO_ZONE[countryCode.toUpperCase()] ?? "MONDE";
}
function servedRank(servedZones, servedCountries, countryCode) {
  const dest = countryCode.toUpperCase();
  const zones = servedZones ?? [];
  const countries = servedCountries ?? [];
  if (countries.some((c) => c.toUpperCase() === dest)) return 3;
  if (zones.includes(resolveZone(dest))) return 2;
  if (zones.includes("MONDE")) return 1;
  return 0;
}
function isServed(servedZones, servedCountries, countryCode) {
  return servedRank(servedZones, servedCountries, countryCode) > 0;
}

// src/carrier-credentials.ts
var TRACKING_CARRIER_CREDENTIALS = (() => {
  const result = {};
  for (const [code, def] of Object.entries(CARRIER_REGISTRY)) {
    const creds = def.credentials;
    if (creds) {
      result[code] = {
        usedFor: creds.usedFor,
        fields: creds.fields,
        oauth: creds.oauth,
        ipWhitelist: creds.ipWhitelist,
        supportsCredentialCheck: creds.supportsCredentialCheck
      };
    }
  }
  return result;
})();
function carrierRequiresCredentials(code) {
  return code in TRACKING_CARRIER_CREDENTIALS;
}
function getCarrierCredentialFields(code) {
  return TRACKING_CARRIER_CREDENTIALS[code]?.fields;
}
function getCarrierCredentialUsedFor(code) {
  return TRACKING_CARRIER_CREDENTIALS[code]?.usedFor;
}
function carrierUsesOAuth(code) {
  return TRACKING_CARRIER_CREDENTIALS[code]?.oauth === true;
}
function carrierSupportsCredentialCheck(code) {
  return TRACKING_CARRIER_CREDENTIALS[code]?.supportsCredentialCheck === true;
}
function getCarrierCredentialIpWhitelist(code) {
  return TRACKING_CARRIER_CREDENTIALS[code]?.ipWhitelist;
}
function getCredentialFieldUsedFor(code, field) {
  return field.usedFor ?? getCarrierCredentialUsedFor(code) ?? [];
}
function getCarrierCredentialFieldsFor(code, usage) {
  return (getCarrierCredentialFields(code) ?? []).filter(
    (field) => getCredentialFieldUsedFor(code, field).includes(usage)
  );
}
function carrierSplitsCredentialsByUsage(code) {
  const usedFor = getCarrierCredentialUsedFor(code) ?? [];
  if (usedFor.length < 2) return false;
  return usedFor.every(
    (usage) => (getCarrierCredentialFields(code) ?? []).some((field) => {
      const fieldUsedFor = getCredentialFieldUsedFor(code, field);
      return fieldUsedFor.length === 1 && fieldUsedFor[0] === usage;
    })
  );
}
function getCarrierPrimaryCredentialUsage(code) {
  const usedFor = getCarrierCredentialUsedFor(code);
  if (!usedFor?.length) return void 0;
  return usedFor.includes("tracking") ? "tracking" : "shipment";
}
function isCredentialValueFilled(value) {
  if (typeof value === "string") return value.trim().length > 0;
  return value !== void 0 && value !== null;
}
function getCredentialUsageState(code, usage, values) {
  const fields = getCarrierCredentialFieldsFor(code, usage);
  const ownFields = carrierSplitsCredentialsByUsage(code) ? fields.filter(
    (field) => getCredentialFieldUsedFor(code, field).length === 1
  ) : fields;
  const isStarted = ownFields.some(
    (field) => field.type === "string" && isCredentialValueFilled(values[field.key])
  );
  if (!isStarted) return "empty";
  return getMissingCredentialFields(code, usage, values).length === 0 ? "complete" : "incomplete";
}
function getMissingCredentialFields(code, usage, values) {
  return getCarrierCredentialFieldsFor(code, usage).filter(
    (field) => field.required && !isCredentialValueFilled(values[field.key])
  );
}
function getConfiguredCredentialUsages(code, values) {
  return (getCarrierCredentialUsedFor(code) ?? []).filter(
    (usage) => getCredentialUsageState(code, usage, values) === "complete"
  );
}
function pickCredentialsFor(code, usage, values) {
  const foreignKeys = new Set(
    (getCarrierCredentialFields(code) ?? []).filter((field) => !getCredentialFieldUsedFor(code, field).includes(usage)).map((field) => field.key)
  );
  return Object.fromEntries(
    Object.entries(values).filter(([key]) => !foreignKeys.has(key))
  );
}
function clearCredentialsFor(code, usage, values) {
  if (!carrierSplitsCredentialsByUsage(code)) return {};
  const remaining = { ...values };
  for (const field of getCarrierCredentialFieldsFor(code, usage)) {
    const fieldUsedFor = getCredentialFieldUsedFor(code, field);
    if (fieldUsedFor.length === 1) delete remaining[field.key];
  }
  const isAnyUsageLeft = (getCarrierCredentialUsedFor(code) ?? []).some(
    (other) => getCredentialUsageState(code, other, remaining) !== "empty"
  );
  return isAnyUsageLeft ? remaining : {};
}

// src/canonicalization.ts
var PRODUCT_ALIASES = {
  colissimo: {
    colissimov2: "colissimo",
    "colissimo-dom": "colissimo",
    "colissimo-home": "colissimo"
  },
  chronopost: {
    "chrono-13": "chronopost-13",
    "chrono13": "chronopost-13"
  },
  // Two generations of DHL codes coexist for the same products, both valid, so
  // nothing brought them together: a shop on the generic read none of the lanes
  // written on the specific. The specific wins, being the only complete set (the
  // generic cannot express Euroconnect). `dhl` stays out: it is standard, not express.
  dhl: {
    "dhl-express": "dhl_express_worldwide",
    express: "dhl_express_worldwide"
  },
  // Global-e has exactly one product in the registry: `express` is a label a
  // shop typed, not a distinct service.
  "global-e": {
    express: "global-e"
  }
};
function canonicalizeCarrierProduct(carrierCode, productCode) {
  if (productCode === null) {
    return null;
  }
  const normalizedProduct = productCode.toLowerCase().trim();
  const normalizedCarrier = carrierCode.toLowerCase().trim();
  const carrierAliases = PRODUCT_ALIASES[normalizedCarrier];
  if (carrierAliases && carrierAliases[normalizedProduct]) {
    return carrierAliases[normalizedProduct];
  }
  const carrierDef = CARRIER_REGISTRY[normalizedCarrier];
  if (carrierDef?.products) {
    const matchedProduct = carrierDef.products.find(
      (p) => p.code.toLowerCase() === normalizedProduct
    );
    if (matchedProduct) {
      return matchedProduct.code;
    }
  }
  return normalizedProduct;
}
function isKnownCarrier(carrierCode) {
  return carrierCode.toLowerCase() in CARRIER_REGISTRY;
}

// src/source-product.ts
function getDefinitionOrUndefined(carrierCode) {
  const normalized = carrierCode.toLowerCase().trim();
  return CARRIER_REGISTRY[normalized];
}
function normalizeSourceProductLabel(label) {
  return label.toLowerCase().replace(/\bapi\b/g, "").replace(/\s+/g, " ").trim();
}
function hasSourceProductMap(carrierCode) {
  return Boolean(getDefinitionOrUndefined(carrierCode)?.sourceProductMap);
}
function resolveSourceCarrierProduct(carrierCode, sourceLabel) {
  if (!sourceLabel) {
    return null;
  }
  const sourceProductMap = getDefinitionOrUndefined(carrierCode)?.sourceProductMap;
  if (!sourceProductMap) {
    return null;
  }
  return sourceProductMap[normalizeSourceProductLabel(sourceLabel)] ?? null;
}

// src/delivery-calendar/types.ts
var EPOCH_DAY_OF_WEEK = 4;

// src/delivery-calendar/calendar.ts
var DAY_MS = 24 * 60 * 60 * 1e3;
var DEFAULT_DELIVERY_CALENDAR = Object.freeze({
  deliveryDays: Object.freeze([1, 2, 3, 4, 5]),
  source: "default"
});
function resolveDeliveryCalendar(carrierCode, carrierProduct) {
  const products = carrierCode && carrierCode in CARRIER_REGISTRY ? getDefinition(carrierCode).products : [];
  if (carrierProduct && carrierProduct !== carrierCode) {
    const days = findDeliveryDays(products, carrierProduct);
    if (days) return { deliveryDays: days, source: "product" };
  }
  if (carrierCode) {
    const days = findDeliveryDays(products, carrierCode);
    if (days) return { deliveryDays: days, source: "carrier" };
  }
  return DEFAULT_DELIVERY_CALENDAR;
}
function businessElapsedMs(fromMs, toMs, calendar) {
  if (!(toMs > fromMs)) return 0;
  const deliveryDays = new Set(
    calendar.deliveryDays.filter((day) => day >= 0 && day <= 6)
  );
  if (deliveryDays.size === 0) return 0;
  const firstDay = Math.floor(fromMs / DAY_MS);
  const lastDay = Math.floor(toMs / DAY_MS);
  if (firstDay === lastDay) {
    return isDeliveryDay(firstDay, deliveryDays) ? toMs - fromMs : 0;
  }
  let elapsed = countDeliveryDays(firstDay + 1, lastDay - 1, deliveryDays) * DAY_MS;
  if (isDeliveryDay(firstDay, deliveryDays)) {
    elapsed += (firstDay + 1) * DAY_MS - fromMs;
  }
  if (isDeliveryDay(lastDay, deliveryDays)) {
    elapsed += toMs - lastDay * DAY_MS;
  }
  return elapsed;
}
function findDeliveryDays(products, code) {
  const days = products.find((product) => product.code === code)?.defaultSmartDelivery?.deliveryDays;
  return days && days.length > 0 ? days : null;
}
function isDeliveryDay(dayIndex, deliveryDays) {
  return deliveryDays.has(((dayIndex + EPOCH_DAY_OF_WEEK) % 7 + 7) % 7);
}
function countDeliveryDays(fromDay, toDay, deliveryDays) {
  if (toDay < fromDay) return 0;
  const dayCount = toDay - fromDay + 1;
  const fullWeeks = Math.floor(dayCount / 7);
  let count = fullWeeks * deliveryDays.size;
  for (let offset = fullWeeks * 7; offset < dayCount; offset += 1) {
    if (isDeliveryDay(fromDay + offset, deliveryDays)) count += 1;
  }
  return count;
}

// src/delivery-calendar/mongo-expressions.ts
var DAY_MS2 = 24 * 60 * 60 * 1e3;
function buildIsBusinessDayVector(deliveryDays) {
  const deliverySet = new Set(
    deliveryDays.filter((d) => d >= 0 && d <= 6)
  );
  return [0, 1, 2, 3, 4, 5, 6].map((d) => deliverySet.has(d) ? 1 : 0);
}
function buildMiddleDaysMatrix(deliveryDays) {
  const deliverySet = new Set(
    deliveryDays.filter((d) => d >= 0 && d <= 6)
  );
  const matrix = [];
  for (let startDow = 0; startDow < 7; startDow++) {
    const row = [];
    for (let remainderDays = 0; remainderDays <= 7; remainderDays++) {
      let count = 0;
      for (let offset = 1; offset <= remainderDays; offset++) {
        const dow = (startDow + offset) % 7;
        if (deliverySet.has(dow)) count++;
      }
      row.push(count);
    }
    matrix.push(row);
  }
  return matrix;
}
function weeklyBusinessDays(deliveryDays) {
  const deliverySet = new Set(
    deliveryDays.filter((d) => d >= 0 && d <= 6)
  );
  return deliverySet.size;
}
function buildVectorLookupExpr(indexExpr, vector) {
  return {
    $switch: {
      branches: vector.map((value, index) => ({
        case: { $eq: [indexExpr, index] },
        then: value
      })),
      default: 0
    }
  };
}
function buildMatrixLookupExpr(rowExpr, colExpr, matrix) {
  return {
    $switch: {
      branches: matrix.map((row, rowIndex) => ({
        case: { $eq: [rowExpr, rowIndex] },
        then: {
          $switch: {
            branches: row.map((value, colIndex) => ({
              case: { $eq: [colExpr, colIndex] },
              then: value
            })),
            default: 0
          }
        }
      })),
      default: 0
    }
  };
}
function buildDowExpr(dayIndexExpr) {
  return {
    $mod: [
      {
        $add: [
          { $mod: [{ $add: [dayIndexExpr, EPOCH_DAY_OF_WEEK] }, 7] },
          7
        ]
      },
      7
    ]
  };
}
function buildBusinessElapsedMsExpr(fromMsExpr, toMsExpr, isBusinessDay, middleDaysMatrix, businessDaysPerWeek) {
  return {
    $let: {
      vars: {
        fromMs: fromMsExpr,
        toMs: toMsExpr
      },
      in: {
        $cond: {
          // Invalid: null operands or negative duration
          if: {
            $or: [
              { $eq: ["$$fromMs", null] },
              { $eq: ["$$toMs", null] },
              { $lt: ["$$toMs", "$$fromMs"] }
              // BAB-3251: strictly less → null
            ]
          },
          then: null,
          else: {
            $cond: {
              // Zero duration: toMs === fromMs — valid, returns 0
              if: { $eq: ["$$toMs", "$$fromMs"] },
              then: 0,
              // Positive duration: toMs > fromMs — compute business time
              else: {
                $let: {
                  vars: {
                    // Day index (since epoch) for start and end
                    startDay: { $floor: { $divide: ["$$fromMs", DAY_MS2] } },
                    endDay: { $floor: { $divide: ["$$toMs", DAY_MS2] } }
                  },
                  in: {
                    $let: {
                      vars: {
                        startDow: buildDowExpr("$$startDay"),
                        endDow: buildDowExpr("$$endDay"),
                        // Milliseconds from fromMs to end of start day
                        endOfStartDayMs: {
                          $multiply: [{ $add: ["$$startDay", 1] }, DAY_MS2]
                        },
                        // Milliseconds at start of end day
                        startOfEndDayMs: { $multiply: ["$$endDay", DAY_MS2] }
                      },
                      in: {
                        $cond: {
                          // Same day case
                          if: { $eq: ["$$startDay", "$$endDay"] },
                          then: {
                            // If business day, return span; else 0
                            $cond: {
                              if: {
                                $eq: [
                                  buildVectorLookupExpr(
                                    "$$startDow",
                                    isBusinessDay
                                  ),
                                  1
                                ]
                              },
                              then: { $subtract: ["$$toMs", "$$fromMs"] },
                              else: 0
                            }
                          },
                          // Multi-day case
                          else: {
                            $let: {
                              vars: {
                                // Number of full days between start and end (exclusive)
                                middleDays: {
                                  $subtract: [
                                    { $subtract: ["$$endDay", "$$startDay"] },
                                    1
                                  ]
                                },
                                // Partial first day contribution
                                partialFirst: {
                                  $cond: {
                                    if: {
                                      $eq: [
                                        buildVectorLookupExpr(
                                          "$$startDow",
                                          isBusinessDay
                                        ),
                                        1
                                      ]
                                    },
                                    then: {
                                      $subtract: [
                                        "$$endOfStartDayMs",
                                        "$$fromMs"
                                      ]
                                    },
                                    else: 0
                                  }
                                },
                                // Partial last day contribution
                                partialLast: {
                                  $cond: {
                                    if: {
                                      $eq: [
                                        buildVectorLookupExpr(
                                          "$$endDow",
                                          isBusinessDay
                                        ),
                                        1
                                      ]
                                    },
                                    then: {
                                      $subtract: ["$$toMs", "$$startOfEndDayMs"]
                                    },
                                    else: 0
                                  }
                                }
                              },
                              in: {
                                $let: {
                                  vars: {
                                    // Full weeks in the middle
                                    fullWeeks: {
                                      $floor: { $divide: ["$$middleDays", 7] }
                                    },
                                    // Remainder days (0-6)
                                    remainder: { $mod: ["$$middleDays", 7] }
                                  },
                                  in: {
                                    $let: {
                                      vars: {
                                        // Business days from full weeks
                                        fullWeeksDays: {
                                          $multiply: [
                                            "$$fullWeeks",
                                            businessDaysPerWeek
                                          ]
                                        },
                                        // Business days from remainder (lookup in matrix)
                                        remainderDays: buildMatrixLookupExpr(
                                          "$$startDow",
                                          "$$remainder",
                                          middleDaysMatrix
                                        )
                                      },
                                      in: {
                                        // Total: partialFirst + middleMs + partialLast
                                        $add: [
                                          "$$partialFirst",
                                          {
                                            $multiply: [
                                              {
                                                $add: [
                                                  "$$fullWeeksDays",
                                                  "$$remainderDays"
                                                ]
                                              },
                                              DAY_MS2
                                            ]
                                          },
                                          "$$partialLast"
                                        ]
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
}

export { CARRIERS_NAMES, CARRIER_REGISTRY, COUNTRY_TO_ZONE, DEFAULT_DELIVERY_CALENDAR, SUPPORTED_TRACKING_CARRIERS, TRACKING_CARRIER_CREDENTIALS, ZONES, buildBusinessElapsedMsExpr, buildIsBusinessDayVector, buildMiddleDaysMatrix, businessElapsedMs, canonicalizeCarrierProduct, carrierRequiresCredentials, carrierSplitsCredentialsByUsage, carrierSupportsCredentialCheck, carrierUsesOAuth, clearCredentialsFor, detectCarrierFromTrackingNumber, detectCarrierFromTrackingUrl, extractPickupPointFromCartAttributes, getAllCarriersWithProducts, getCarrierCredentialFields, getCarrierCredentialFieldsFor, getCarrierCredentialIpWhitelist, getCarrierCredentialUsedFor, getCarrierLabel, getCarrierLogoFilename, getCarrierPrimaryCredentialUsage, getCarrierProducts, getConfiguredCredentialUsages, getCredentialFieldUsedFor, getCredentialUsageState, getDefinition, getMissingCredentialFields, getProductName, getTrackingMoreCarrierCode, hasSourceProductMap, isCredentialValueFilled, isKnownCarrier, isNativeCarrier, isServed, isSupportedTrackingCarrier, isTrackingMoreCarrier, mapToCanonicalCarrierCode, matchShippingLineToProduct, matchShippingLineToProductWithSource, normalizeSourceProductLabel, observesPublicHolidays, pickCredentialsFor, resolveCarrierBrand, resolveDeliveryCalendar, resolveSourceCarrierProduct, resolveZone, servedRank, supportsLabelGeneration, supportsPickupRequest, weeklyBusinessDays };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map